/** @jsx jsx */
import { css, jsx, useTheme } from '@emotion/react';
import React from 'react';

var BreadcrumbsSeperator = function BreadcrumbsSeperator(_ref) {
  var children = _ref.children;
  var theme = useTheme();
  var rootStyles = /*#__PURE__*/css({
    position: 'absolute',
    right: theme.direction === 'ltr' ? '-5px' : undefined,
    left: theme.direction === 'rtl' ? '-5px' : undefined,
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 1,
    color: '#77818f',
    content: '""',
    width: '15px'
  }, process.env.NODE_ENV === "production" ? "" : ";label:rootStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0JyZWFkY3J1bWJzU2VwZXJhdG9yLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFVcUIiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvQnJlYWRjcnVtYnNTZXBlcmF0b3IudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5cbmltcG9ydCB7IGNzcywganN4LCB1c2VUaGVtZSB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmNvbnN0IEJyZWFkY3J1bWJzU2VwZXJhdG9yOiBSZWFjdC5GQyA9ICh7XG4gIGNoaWxkcmVuLFxufSkgPT4ge1xuICBjb25zdCB0aGVtZSA9IHVzZVRoZW1lKCk7XG5cbiAgY29uc3Qgcm9vdFN0eWxlcyA9IGNzcyh7XG4gICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgcmlnaHQ6IHRoZW1lLmRpcmVjdGlvbiA9PT0gJ2x0cicgPyAnLTVweCcgOiB1bmRlZmluZWQsXG4gICAgbGVmdDogdGhlbWUuZGlyZWN0aW9uID09PSAncnRsJyA/ICctNXB4JyA6IHVuZGVmaW5lZCxcbiAgICB0b3A6ICc1MCUnLFxuICAgIHRyYW5zZm9ybTogJ3RyYW5zbGF0ZVkoLTUwJSknLFxuICAgIHpJbmRleDogMSxcbiAgICBjb2xvcjogJyM3NzgxOGYnLFxuICAgIGNvbnRlbnQ6ICdcIlwiJyxcbiAgICB3aWR0aDogJzE1cHgnLFxuICB9KTtcblxuICByZXR1cm4gKFxuICAgIDxkaXYgY3NzPXtyb290U3R5bGVzfT5cbiAgICAgIHtjaGlsZHJlbn1cbiAgICA8L2Rpdj5cbiAgKTtcbn07XG5cbkJyZWFkY3J1bWJzU2VwZXJhdG9yLmRpc3BsYXlOYW1lID0gJ0JyZWFkY3J1bWJzU2VwZXJhdG9yJztcblxuZXhwb3J0IGRlZmF1bHQgQnJlYWRjcnVtYnNTZXBlcmF0b3I7XG4iXX0= */");
  return jsx("div", {
    css: rootStyles
  }, children);
};

BreadcrumbsSeperator.displayName = 'BreadcrumbsSeperator';
export default BreadcrumbsSeperator;